interface AppConfig {
  apiUrl: string;
  environment: string;
  version: string;
}

let cachedConfig: AppConfig | null = null;

export const getConfig = async (): Promise<AppConfig> => {
  if (cachedConfig) {
    return cachedConfig;
  }

  try {
    // Intentar cargar la configuración desde el archivo JSON
    const response = await fetch('/config.json');
    if (response.ok) {
      const config = await response.json();
      cachedConfig = config;
      return config;
    }
  } catch (error) {
    console.warn('No se pudo cargar config.json, usando configuración por defecto');
  }

  // Fallback para desarrollo
  const fallbackConfig: AppConfig = {
    apiUrl: process.env.REACT_APP_API_URL || 'http://localhost:7001/api',
    environment: process.env.NODE_ENV || 'development',
    version: '1.0.0'
  };
  
  cachedConfig = fallbackConfig;
  return fallbackConfig;
};

export const getApiUrl = async (): Promise<string> => {
  const config = await getConfig();
  return config.apiUrl;
};
